import { render, staticRenderFns } from "./ComboAdder.vue?vue&type=template&id=81db411a&scoped=true"
import script from "./ComboAdder.vue?vue&type=script&lang=js"
export * from "./ComboAdder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81db411a",
  null
  
)

export default component.exports